import React, { useState, useContext, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import ImageUpload from '../../shared/components/FormElements/ImageUpload/ImageUpload';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import { useForm } from '../../shared/hooks/form-hook';
import Button from '../../shared/components/FormElements/Button/Button';
import './QuestionAnswer.css';

const QuestionAnswer = props => {

    const _sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const location = useLocation();
    const questionId = useParams().questionId;
    const question = useParams().question;

    const auth = useContext(AuthContext);
    const navigate = useNavigate();
    const { isLoading, error, sendRequest, clearError } = useHttpClient();
    const [filePath, setFilePath] = useState();
    const [evaluateEnabled, setEvaluatedEnabled] = useState(false);


    const [formState, inputHandler] = useForm(
        {
        video: {
            value: null,
            isValid: false
        }
        },
        false
    );

    const evaluateHandler = async(event) => {
        event.preventDefault();
        console.log(filePath);

        try {
            const responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL_PLAN+`/generate/${questionId}`, 'POST',
            JSON.stringify({
                filepath: filePath
            }),
            {
                "Content-Type": "application/json", 
                Authorization: 'Bearer '+auth.token
            });

            navigate(`/question/report/evaluation/${responseData.evaluation._id}`);
        } catch (err) {

        }
    };

    useEffect(()=>{
        const sleep = async() => {
            await _sleep(30000);
        };
        if (location.state) {
            setFilePath(location.state.filepath);
            sleep();
            setEvaluatedEnabled(true);
        }
    },[location]);

    const pickedHandler = (filepath) => {
        const sleep = async() => {
            await _sleep(30000);
        };
        setFilePath(filepath);
        sleep();
        setEvaluatedEnabled(true);
    };

    return (
        <React.Fragment>
            <ErrorModal error={error} onClear={clearError}/>
            {isLoading && <LoadingSpinner asOverlay pleaseWait video={filePath} />}
            {!isLoading && 
            <div className='questionanswer-page'>
            <div className='question-answer'><h1 className='question-answer'>{question}?</h1></div>
            <div className='tips'>
            <p>TIPS: Make your response concise under 2 minutes, and make sure your sound quality is good for more clarity.</p>
            <p>TIPS: Maintain your posture and eye contact. Dress appropriately in real interviews. But most importantly...Have fun!</p>
            </div>
            <form onSubmit={evaluateHandler}>
                <div className='imagePreview'>
                <ImageUpload center id="video" onInput={inputHandler} questionId={questionId} onPick={pickedHandler} filepath={filePath} />
                <div className='question-answer-buttons'>
                    <Button to={`/webcam/${questionId}/${question}`}>RECORD VIDEO</Button>
                    <Button disabled={!evaluateEnabled}>EVALUATE</Button>
                </div>
                </div>
            </form>
            </div>
            }
        </React.Fragment>
    );

};

export default QuestionAnswer;